<template>
  <CFooter :fixed="false">
    <div>
      <a href="#" target="_blank">Bizlynk</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}}</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="https://boffintechnolabs.com" target="_blank">Boffin Techno Labs</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
